<template>
  <InputWrapper
    :id="id"
    :label="label"
    :disabled="disabled"
    :label-position="labelPosition"
    :label-class="labelClass"
    :unit="unit"
    :custom-classes="
      !isValid || inputValue === ''
        ? 'border-t-[1px] border-b-[1px] border-transparent'
        : ''
    "
  >
    <select
      :id="id"
      v-model="inputValue"
      class="w-full appearance-none rounded pl-4 text-lg hover:cursor-pointer focus:border-[#24272A] focus:outline-none focus:ring-0 disabled:cursor-not-allowed"
      :class="{
        'border-[#E4E7EE] text-neutral-50': inputValue === '' || disabled,
        'border-[#FDA29B] focus:border-[#FDA29B]': !isValid,
        'border-2 border-[#6BD29B] focus:border-[#6BD29B]':
          isValid && inputValue !== '',
      }"
      :disabled="disabled"
      @change="onChange"
    >
      <option
        v-if="placeholder && !showPlaceholderInBetween"
        value=""
        disabled
        selected
      >
        {{ placeholder }}
      </option>
      <template
        v-for="(
          { label: optionLabel, value: optionValue }, optionId
        ) in options"
        :key="optionId"
      >
        <option
          v-if="
            placeholder &&
            showPlaceholderInBetween &&
            placeholderBeforeValue == optionValue
          "
          value=""
          disabled
          selected
        >
          {{ placeholder }}
        </option>
        <option :value="optionValue">
          {{ optionLabel }}
        </option>
      </template>
    </select>
  </InputWrapper>
</template>
<script setup lang="ts">
import type { Value } from '@scayle/storefront-nuxt'
const props = defineProps({
  id: {
    type: String as PropType<string>,
    required: true,
  },
  value: {
    type: [Number, String] as PropType<number | string>,
    required: true,
  },
  options: {
    type: [Object, Array] as PropType<Value[] | Value[]>,
    required: true,
  },
  label: {
    type: String as PropType<string>,
    required: true,
  },
  labelClass: {
    type: String as PropType<string>,
    default: '',
  },
  labelPosition: {
    type: String as PropType<'left' | 'top'>,
    default: 'top',
  },
  placeholder: {
    type: String as PropType<string>,
    default: '',
  },
  placeholderBeforeValue: {
    type: String as PropType<string | number>,
    default: undefined,
  },
  unit: {
    type: String as PropType<string>,
    default: '',
  },
  disabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  isValid: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
})

const emit = defineEmits(['selected', 'update:value'])

const { value } = toRefs(props)
const inputValue = ref(props.value)

const scope = effectScope()
onScopeDispose(() => scope.stop())

scope.run(() => {
  if (import.meta.server) {
    return
  }
  watch(value, (newValue) => {
    inputValue.value = newValue
  })
})

const onChange = () => {
  emit('update:value' as any, inputValue.value)
}

const showPlaceholderInBetween = computed(() => {
  return (
    props.placeholderBeforeValue !== undefined &&
    props.options.some(
      (option) => option.value === props.placeholderBeforeValue,
    )
  )
})
</script>
<style lang="scss" scoped>
select {
  background: transparent;
  background-image: url('~/assets/icons/fielmann/ChevronDown.svg?inline');
  background-repeat: no-repeat no-repeat;
  background-size: 22px;
  background-position-x: calc(100% - 13px);
  background-position-y: 50%;
}
</style>
